export const COMPLAINT_STATUS = {
  OPEN: "Open",
  IN_PROGRESS: "In Progress",
  RESOLVED: "Resolved",
};

export const COMPLAINT_STATUS_OPTIONS = [
  COMPLAINT_STATUS.OPEN,
  COMPLAINT_STATUS.IN_PROGRESS,
  COMPLAINT_STATUS.RESOLVED,
];

const COMPLAINT_STATUS_ALIASES = {
  open: COMPLAINT_STATUS.OPEN,
  "in progress": COMPLAINT_STATUS.IN_PROGRESS,
  "in process": COMPLAINT_STATUS.IN_PROGRESS,
  "in-process": COMPLAINT_STATUS.IN_PROGRESS,
  resolved: COMPLAINT_STATUS.RESOLVED,
  close: COMPLAINT_STATUS.RESOLVED,
  closed: COMPLAINT_STATUS.RESOLVED,
};

export const normalizeComplaintStatus = (status) => {
  if (!status) {
    return COMPLAINT_STATUS.OPEN;
  }

  const normalizedStatus = String(status).trim().toLowerCase();
  return COMPLAINT_STATUS_ALIASES[normalizedStatus] || COMPLAINT_STATUS.OPEN;
};

export const isComplaintClosed = (status) =>
  normalizeComplaintStatus(status) === COMPLAINT_STATUS.RESOLVED;

export const getComplaintStatusColor = (status) => {
  const normalizedStatus = normalizeComplaintStatus(status);

  if (normalizedStatus === COMPLAINT_STATUS.OPEN) {
    return "info";
  }

  if (normalizedStatus === COMPLAINT_STATUS.IN_PROGRESS) {
    return "warning";
  }

  if (normalizedStatus === COMPLAINT_STATUS.RESOLVED) {
    return "success";
  }

  return "default";
};